<template>
<v-dialog
  v-model="dialog"
  width="500"
  transition="dialog-bottom-transition"
>

<v-toolbar
  dark
  color="#0f3057"
>
  <v-btn
    icon
    dark
    @click="dialog = false"
  >
    <v-icon>mdi-close</v-icon>
  </v-btn>
  <v-toolbar-title>Nouvelle dépense</v-toolbar-title>
  <v-spacer></v-spacer>
  <v-toolbar-items>
    <v-btn
      dark
      text
      @click="dialog = false"
    >
      Save
    </v-btn>
  </v-toolbar-items>
</v-toolbar>
<v-card>
  <v-col>
    <v-text-field label="Nom de dépense" ></v-text-field>
    <v-text-field type="number" label="Prix de dépense"></v-text-field>
    <v-file-input label="Reçu"></v-file-input>
  </v-col>

</v-card>
</v-dialog>
</template>
<script>
export default {
  props: {
    value: Boolean
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
